import {
    ORDER_SCHEDULED_TASKS_REQUEST,
    ORDER_SCHEDULED_TASKS_SUCCESS,
    ORDER_SCHEDULED_TASKS_FAILURE
} from '../actions';


const initialState = {};

const OrderScheduledTasksReducer = (state = initialState, action) => {
    switch (action.type) {
        case ORDER_SCHEDULED_TASKS_REQUEST:
            return Object.assign({},state, {asyncStatus:  'PENDING'});
        case ORDER_SCHEDULED_TASKS_SUCCESS:
            return Object.assign({},state, {asyncStatus:  'SUCCESS', data: action.payload});
        case ORDER_SCHEDULED_TASKS_FAILURE:
            return Object.assign({},state, {asyncStatus:  'FAILURE', data: action.payload});
        default:
            return state;
    }
};

export default OrderScheduledTasksReducer;